let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lRsSW")).then(() => parcelRequire('6tp8x'));